// config/loginConfig.js

const LOGIN_ROUTES = {
  'elearning.euniso.so': 'student-login',
};

const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
export const isManagedDomain = Object.prototype.hasOwnProperty.call(LOGIN_ROUTES, hostname);
// console.log("isManaged: ",isManagedDomain,"hostname: ",hostname);
export const LOGIN_ROUTE = LOGIN_ROUTES[hostname] || 'user-login';

export const LOGIN_PATH = isLocalhost
  ? window.location.pathname 
  : `/login/${LOGIN_ROUTE}`;